export default "__VITE_ASSET__DhH7akAN__"